import type { PurchaseSummary } from '@src/common/types/purchaseSummary';
import {
  getOrderSaleItems,
  getOrderTotalCurrencyInfo,
  getOrderServiceFeeCurrencyInfo,
  getOrderServiceFeeDescriptions,
  getOrderCoupon,
  type Order,
} from '@src/domains/orders';

export const toPurchaseSummary = (order: Order): PurchaseSummary => ({
  items: getOrderSaleItems(order),
  totalAmountCents: getOrderTotalCurrencyInfo(order)?.amountCents ?? 0,
  serviceFeeCurrencyInfo: getOrderServiceFeeCurrencyInfo(order),
  serviceFeeDescriptions: getOrderServiceFeeDescriptions(order),
  coupon: getOrderCoupon(order),
});
